module.exports = __webpack_public_path__ + "static/media/About-Us-Header.02eef57f.png";